export default __webpack_public_path__ + "static/media/tatianemodena-2-700x1080Tiny.38043a16.png";